// export const SERVER_URL = "http://localhost:8000";
export const SERVER_URL = "https://api.enterscience.com.br";

export const API_URL = SERVER_URL + "/api";
export const ADMIN_URL = SERVER_URL + "/api/admin";